import initSlideshow from "../initSlideshow.js";

document.addEventListener("DOMContentLoaded", () => {
  initSlideshow();
});
